import { ReactNode } from "react";
import { FluentBundle, FluentResource } from "@fluent/bundle";
import { ReactLocalization, LocalizationProvider } from "@fluent/react";
import { Language } from "./types/locale";
import { useAppSelector } from "./store/hooks";

import danishLocale from "!!raw-loader!./lang/da-DK.ftl"; // eslint-disable-line import/no-webpack-loader-syntax
import englishLocale from "!!raw-loader!./lang/en-GB.ftl"; // eslint-disable-line import/no-webpack-loader-syntax
import dutchLocale from "!!raw-loader!./lang/nl-NL.ftl"; // eslint-disable-line import/no-webpack-loader-syntax

const languageBundles: { [K in Language]: FluentBundle } = {
	"da-DK": new FluentBundle("da-DK"),
	"en-GB": new FluentBundle("en-GB"),
	"nl-NL": new FluentBundle("nl-NL"),
};

languageBundles["da-DK"].addResource(new FluentResource(danishLocale));
languageBundles["en-GB"].addResource(new FluentResource(englishLocale));
languageBundles["nl-NL"].addResource(new FluentResource(dutchLocale));

interface AppLocalizationProviderProps {
	children: ReactNode;
}

export default function AppLocalizationProvider(props: AppLocalizationProviderProps) {
	const currentLocale = useAppSelector(state => state.locale);

	let l10n;

	switch (currentLocale.language) {
		case "da-DK":
			l10n = new ReactLocalization([languageBundles["da-DK"], languageBundles["en-GB"]]);
			break;

		case "en-GB":
			l10n = new ReactLocalization([languageBundles["en-GB"], languageBundles["da-DK"]]);
			break;

		case "nl-NL":
			l10n = new ReactLocalization([languageBundles["nl-NL"], languageBundles["en-GB"]]);
			break;
	}

	return (
		<LocalizationProvider l10n={l10n}>
			{props.children}
		</LocalizationProvider>
	);
}
